export {
  isProductionEnv, isTestEnv, getAppEnvironment, getAWSRegion,
} from './environment';
